const middleware = {}

middleware['authenticated'] = require('../client/middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['route-redirect'] = require('../client/middleware/route-redirect.js')
middleware['route-redirect'] = middleware['route-redirect'].default || middleware['route-redirect']

export default middleware
